import React, { useState } from "react";
import FooterFour from "../components/footers/FooterFour";
import Feature from "../features/landingpage-four/Feature";
import GetStarted from "../features/landingpage-four/GetStarted";
import Products from "../features/landingpage-four/Products";
import Subscribe from "../features/landingpage-four/Subscribe";
import TeamSection from "../features/landingpage-four/TeamSection";
import { Link } from "react-router-dom";

const LandingPageFour = () => {
    const [dataBlock] = useState({
        name:"Awesome",
        title: "Welcome To The Landik Ui kit",
        subTitle: "Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime The standard chunk of those interested."
    })
  return (
    <>
      <section className="pt-[124px] pb-20 bg-[url('../images/land_bg_four.jpg')] bg-cover bg-center relative ">
        <div className="bg-[url('../images/hero-4-bg.png')] absolute inset-0 bg-no-repeat bg-center bg-cover"></div>
        <div className="container relative">
          <div className="grid grid-cols-1">
            <div className="max-w-[700px] text-center mx-auto w-full bg-white border-[10px] border-custom/10 py-[50px] px-10">
              <p className="uppercase tracking-[4px]">
                <span className="h-[2px] -top-[5px] relative bg-custom w-10 mx-1 inline-block"></span>{" "}
                {dataBlock.name}{" "}
                <span className="h-[2px] -top-[5px] relative bg-custom w-10 mx-1 inline-block"></span>{" "}
              </p>
              <h1 className="font-bold text-4xl md:text-[54px] mt-4 leading-[1.4]">
                {dataBlock.title}
              </h1>
              <p className="text-muted mt-6">
                {dataBlock.subTitle}
              </p>
              <div className="mt-12">
                <a
                  href="#cta_sec"
                  className="h-[50px] w-[50px] leading-[50px] text-[24px] bg-custom inline-block rounded-full"
                >
                  <i className="text-white mdi mdi-chevron-double-down"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20" id="cta_sec">
        <div className="container">
            <div className="grid grid-cols-1">
                <div className="bg-[url('../images/heade_video_bg.jpg')] py-[100px] text-center bg-cover bg-center rounded-[30px]">
                    <h2 className="font-bold text-white max-w-[650px] text-[42px] mx-auto">Landing Design tamplate for your startup.</h2>
                    <p className="mx-auto mt-6 max-w-[600px] text-white">Making a decision to do something – this is the first step. We all know that nothing moves until someone makes a decision.</p>
                </div>
            </div>
        </div>
    </section>
    <Feature/>
    <Products/>
    <TeamSection/>
    <GetStarted/>
    <Subscribe/>
    <FooterFour/>
    </>
  );
};

export default LandingPageFour;
